import LoadingML from './LoadingML';

export default (props) => {
  return <LoadingML {...props} />;
};
